import { Card, Tooltip, Typography, useTheme, alpha } from "@mui/material";
import React from "react";

import { useSelector } from "react-redux";

// Define the component function
const DeviceCardPanel = (props) => {
  const isMobile = useSelector((state) => state.isMobile);
  const { title, content, isWidget } = props;

  const theme = useTheme();

  return (
    <Tooltip title={`${title}: ${content}`} placement="top" arrow>
      <Card
        elevation={0}
        sx={{
          backgroundColor: alpha(theme.palette.background.paper, 0.6),
          border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
          borderRadius: "8px",
          p: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            backgroundColor: alpha(theme.palette.background.paper, 0.9),
            borderColor: alpha(theme.palette.primary.main, 0.2),
          },
        }}
      >
        <Typography
          variant="caption"
          sx={{
            color: theme.palette.text.secondary,
            fontSize: "0.75rem",
            fontWeight: 500,
            textTransform: "uppercase",
            letterSpacing: "0.5px",
            mb: 0.5,
          }}
        >
          {title}
        </Typography>

        <Typography
          variant="body1"
          noWrap={!isMobile}
          sx={{
            fontSize: isWidget ? "1rem" : "0.9rem",
            fontWeight: 600,
            color: theme.palette.text.primary,
            lineHeight: 1.3,
            ...(content === "N/A" && {
              color: theme.palette.text.secondary,
              fontStyle: "italic",
              fontWeight: 400,
            }),
          }}
        >
          {content}
        </Typography>
      </Card>
    </Tooltip>
  );
};

export default React.memo(DeviceCardPanel);
